import { useAuthStore } from '@/store/authStore';
import { useLocalization } from '@/i18n/provider';

interface Props {
  /** Оригинальное английское название */
  englishName: string;
  /** Отображаемое (переведённое) название */
  displayedName: string;
  /** Показывать отдельной строкой под переведённым названием */
  block?: boolean;
  className?: string;
}

/**
 * Отображает английское название в скобках рядом с переведённым.
 * Рендерится только если:
 *   - у пользователя включена настройка show_english_names
 *   - текущий язык не английский
 *   - английское имя отличается от переведённого (т.е. перевод существует)
 */
export function EnglishName({ englishName, displayedName, block = false, className = '' }: Props) {
  const { user } = useAuthStore();
  const { language } = useLocalization();

  if (!user?.show_english_names || language === 'en' || englishName === displayedName) {
    return null;
  }

  return (
    <>
      {!block ? ' ' : null}
      <span className={`wizard-option-english-name ${block ? 'wizard-option-english-name--block' : ''} ${className}`.trim()}>
        ({englishName})
      </span>
    </>
  );
}
